import { render, staticRenderFns } from "./game-list.vue?vue&type=template&id=438db8fa"
import script from "./game-list.vue?vue&type=script&lang=js"
export * from "./game-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/game-list/game-list.vue
// module id = R4+L
// module chunks = 0